import { Box, Flex, Heading, HStack, Text } from "@chakra-ui/react";
import { useObjects } from "./useObjects";
import { Table } from "../../components/Table/Table";
import { DropDown } from "../../components/Select/DropDown";
import { AddProcessModal } from "../../components/AddProcessModal/AddProcessModal";
import { AddRuleModal } from "../../components/AddRuleModal/AddRuleModal";
import { AddCustomDataTypeModal } from "../../components/AddCustomDataTypeModal/AddCustomDataTypeModal";
import { AddFolderModal } from "../../components/AddFolderModal/AddFolderModal";
import { BackButton } from "../../components/BackButton/BackButton";
import { AddConnectedSystemModal } from "../../components/AddConnectedSystemModal/AddConnectedSystemModal";
import { AddHttpIntegrationModal } from "../../components/AddHttpIntegrationModal/AddHttpIntegrationModal";
import { AddRecordTypeModal } from "../../components/AddRecordTypeModal/AddRecordTypeModal";
import {
  ObjectsFilterPanel,
  ObjectsFilterPanelProps,
} from "../../components/FilterPanel/ObjectFilterPanel";
import { useState } from "react";
import { AddWebApiModal } from "../../components/AddWebApiModal/AddWebApiModal";

export const Objects = () => {
  const [filters, setFilters] = useState({
    search: "",
    checkboxes: {
      rule: false,
      process: false,
      customDataType: false,
      connectedSystems: false,
      integration: false,
      floder: false,
      recordType: false,
      webApi: false,
    },
    timeRange: "",
  });

  const handleFilterChange = (newFilters: Partial<ObjectsFilterPanelProps>) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
      checkboxes: {
        ...prev.checkboxes,
        ...(newFilters.checkboxes || {}),
      },
    }));
  };

  // const { columnData, ...otherProps } = useObjects(filters);

  const {
    createNewOptions,
    columns,
    columnData,
    onOptionChange,
    isAddRuleModalOpen,
    onAddRuleModalClose,
    isAddCustomDataTypeModalOpen,
    onAddCustomDataTypeModalModalClose,
    isAddHttpIntegrationModalOpen,
    onAddHttpIntegrationModalClose,
    isAddConnectedSystemModalOpen,
    onAddConnectedSystemModalClose,
    isAddProcessModalOpen,
    onAddProcessModalClose,
    isAddFolderModalOpen,
    onAddFolderModalClose,
    isAddRecordTypeModalOpen,
    onAddRecordTypeModalClose,
    isAddWebApiModalOpen,
    onAddWebApiModalClose,
  } = useObjects(filters);
  return (
    <Box>
      {/* <BackButton /> */}

      <Box>
        <Flex dir="colomn" width={"100%"} gap={2}>
          <Box
            width={"15%"}
            bgColor="rgba(255, 255, 255, 0.05)"
            backdropFilter="blur(20px)"
            borderRadius="20px"
            borderWidth="1px"
            borderColor="rgba(255, 255, 255, 0.1)"
            p={3}
          >
            <ObjectsFilterPanel
              search={filters.search}
              checkboxes={filters.checkboxes}
              timeRange={filters.timeRange}
              onFilterChange={handleFilterChange}
            />
          </Box>
          <Box
            backgroundColor="rgba(255, 255, 255, 0.05)"
            backdropFilter="blur(20px)"
            borderRadius="20px"
            borderWidth="1px"
            borderColor="rgba(255, 255, 255, 0.1)"
            width={"100%"}
          >
            <Box p={6}>
              <HStack justifyContent="space-between">
                <HStack>
                  <Heading fontSize="18px" fontWeight="600">
                    Application Objects
                  </Heading>
                </HStack>
                <Box width="20%">
                  <DropDown
                    selected={undefined}
                    title={<Text fontSize="12px"></Text>}
                    options={createNewOptions}
                    onOptionChange={onOptionChange}
                    placeHolder="Create new"
                  />
                </Box>
              </HStack>
            </Box>

            <Table columns={columns} data={columnData} intialRowsPerPage={10} />
          </Box>
        </Flex>
      </Box>

      <AddCustomDataTypeModal
        isOpen={isAddCustomDataTypeModalOpen}
        onClose={onAddCustomDataTypeModalModalClose}
      />
      <AddConnectedSystemModal
        isOpen={isAddConnectedSystemModalOpen}
        onClose={onAddConnectedSystemModalClose}
      />
      <AddHttpIntegrationModal
        isOpen={isAddHttpIntegrationModalOpen}
        onClose={onAddHttpIntegrationModalClose}
      />
      <AddProcessModal
        isOpen={isAddProcessModalOpen}
        onClose={onAddProcessModalClose}
      />
      <AddRuleModal isOpen={isAddRuleModalOpen} onClose={onAddRuleModalClose} />
      <AddFolderModal
        isOpen={isAddFolderModalOpen}
        onClose={onAddFolderModalClose}
      />
      <AddRecordTypeModal
        isOpen={isAddRecordTypeModalOpen}
        onClose={onAddRecordTypeModalClose}
      />
      <AddWebApiModal
        isOpen={isAddWebApiModalOpen}
        onClose={onAddWebApiModalClose}
      />
    </Box>
  );
};
